/**
 * Created by jonas on 2021-02-09.
 */
import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {BenjiKIVReelModel} from "../../../reels/BenjiKIVReelModel";
import {BenjiKIVStatics} from "../../../BenjiKIVStatics";
import {BenjiKIVReelView} from "./BenjiKIVReelView";
import {BenjiKIV} from "../../../BenjiKIV";
import {gsap} from "gsap";
import {BenjiKIVScatterSymbol} from "../../../reels/BenjiKIVScatterSymbol";

export class BenjiKIVAllReelsView extends PIXI.Container implements StageLayer {

    get reelModels():BenjiKIVReelModel[] {
        return this._reelModels;
    }

    private _reelModels:BenjiKIVReelModel[];
    private _longestReelSymbolBufferSize:number;

    constructor() {
        super();
        this.init();
    }

    private init() {
        this._longestReelSymbolBufferSize = 0;

        this.position = BenjiKIVStatics.MAIN_REELS_VIEW_POSITION;

        const mainReelsMask:PIXI.Graphics = new PIXI.Graphics();
        mainReelsMask.beginFill();
        mainReelsMask.drawRect(0, 0, BenjiKIVStatics.symbolWidth * 5, BenjiKIVStatics.symbolHeight * 3);
        mainReelsMask.position = BenjiKIVStatics.MAIN_REELS_VIEW_MASK_POSITION;
        this.addChild(mainReelsMask);
        this.mask = mainReelsMask;

        this._reelModels = [];
        let tempReel:string[];
        for(let i:number = 0; i < BenjiKIVStatics.defaultGameAreaSize.length; i++) {
            const reelModel = new BenjiKIVReelModel(i);
            tempReel = [];
            this.addChild(<BenjiKIVReelView>reelModel.reelView);

            this._reelModels.push(reelModel);

            //Create reels with 3 padding symbol on top and bottom
            for(let j:number = 0; j < 9; j++) {
                tempReel.push(BenjiKIV.model.data.reels[i][j]);
            }

            reelModel.reelView.init(tempReel);
        }

        //Set correct dice symbol texture on restore
        if(BenjiKIV.model.isRestore == true && this.initSymbolsHasScatter() == true) {
            for(let i:number = 0; i < BenjiKIV.model.scattersLanded.length; i++) {
                if(BenjiKIV.model.scattersLanded[i] > -1) {
                    (<BenjiKIVScatterSymbol>this._reelModels[i].reelView.symbols[BenjiKIV.model.scattersLanded[i]]).setRestoreState(2 + i);
                }
            }
        }
    }

    private initSymbolsHasScatter():boolean {
        for(let i:number = 0; i < BenjiKIV.model.scattersLanded.length; i++) {
            if(BenjiKIV.model.scattersLanded[i] > -1) {
                return true;
            }
        }
        return false;
    }
}